// src/lib/edge/adminAct.ts
/** Canonical admin actions router via BFF (no direct Edge/PostgREST from client). */
export async function adminAct(act: string, payload?: unknown) {
  switch (act) {
    case "wallet.overview": {
      const r = await fetch("/api/admin/wallet-overview", {
        method: "GET",
        credentials: "include",
        headers: { "x-surface": "admin" },
      });
      const t = await r.text();
      if (!r.ok) throw new Error(t || `wallet.overview ${r.status}`);
      return JSON.parse(t);
    }
    default:
      throw new Error(`Unsupported admin act: ${act}`);
  }
}